import { buildAction } from 'store/actions/actionCreator'

import { SET_SORT } from './constants'

export const setSort = buildAction(SET_SORT, 'payload')
